// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Button';



// WEBPACK FOOTER //
// ./components/Button/index.js